<!--  -->
<template>
    <div class="box">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>检测能力</el-breadcrumb-item>
      </el-breadcrumb>
  
      <div class="content">
          <div class="content-box">
              <div class="top">
                  <div class="left">
                      <img src="../../assets/img/jiliangnengli/icon.png" alt="">
                      <div class="text">
                          <div class="title">质检中心</div>
                          <div class="en-text">quality inspection center</div>
                      </div>
                  </div>
              </div>
              <div class="list">
                  <div class="item" v-for="(item, index) in zhijianList" :key="index" @click="toDetail(item)">
                      <img class="img" :src="downloadUrl + item.photo" alt="">
                      <div class="info">
                          <div class="name">
                              <img src="../../assets/img/jiliangnengli/unit-icon.png" class="unit-icon" alt="">
                              <div>{{ item.name }}</div>
                          </div>
                          <!-- <div class="unit"></div> -->
                      </div>
                  </div>
              </div>
              <div class="bottom">
                  <el-pagination
                      layout="prev, pager, next"
                      :total="zhijianTotal"
                      @current-change="jiliangCurrentPage"
                      @prev-click="jiliangShang"
                      @next-click="jiliangXia"
                      :page-size="pageSize"
                  >
                  </el-pagination>
              </div>
          </div>
  
          <div class="content-box" v-if="zhijianTotal >= 0" style="margin: 50px 0;">
              <div class="top">
                  <div class="left">
                      <img src="../../assets/img/jiliangnengli/icon2.jpg" alt="">
                      <div class="text">
                          <div class="title">资质证书</div>
                          <div class="en-text">qualification certificate</div>
                      </div>
                  </div>
              </div>
              <div class="list zizhi">
                  <div class="item" v-for="(item, index) in  zizhiList" :key="index">
                      <!-- <img :src="" alt=""> -->
                      <el-image :src="downloadUrl + item.photo" :preview-src-list="[downloadUrl + item.photo]" class="item-img"></el-image>
                  </div>
              </div>
              <div class="bottom">
                  <el-pagination
                      layout="prev, pager, next"
                      :total="zizhiTotal"
                      @current-change="zizhiCurrentPage"
                      @prev-click="zizhiShang"
                      @next-click="zizhiXia"
                      :page-size="pageSize"
                  >
                  </el-pagination>
              </div>
          </div>
      </div>
    </div>
  </template>
  
  <script>
  import { Server,httpurl } from "@/server";
  export default {
      data () {
          return {
              
              pageSize: 8,
              pageNo: 1,
              zizhiList: [], //资质证书列表
              zhijianList: [], // 产业计量中心列表
              zizhiTotal: 0, // 资质证书总条数
              zhijianTotal: 0, // 产业计量中心总条数
              downloadUrl: '',
          }
      },
      created() {
          this.getZhijianData(1)
          this.getZizhiData(1)
  
          this.downloadUrl = this.$downloadUrl
      },
  
      methods: {
            getZhijianData(num) {
              Server.getJianyanjianceInfo({type: 2,pageSize: 8, pageNo: num}).then(res => {
                  console.log(res);
                  if(res.success) {
                      this.zhijianList = res.result.records
                      this.zhijianTotal = res.result.total
                  }
              })
          },
          getZizhiData(num) {
              Server.getJianyanjianceInfo({type: 1,pageSize: 8, pageNo: num}).then(res => {
                  console.log(res);
                  if(res.success) {
                      this.zizhiList = res.result.records
                      this.zizhiTotal = res.result.total
                  }
              })
          },
          toDetail(item) {
              console.log(item);
              this.$router.push({
                  path: '/jiancenengliDetail',
                  query: {
                      id: item.id
                  }
              })
              
          },
          jiliangCurrentPage(page) {
              this.pageNo = page;
          },
          jiliangXia() {
              this.pageNo = this.pageNo + 1;
              this.getZhijianData(this.pageNo)
          },
          jiliangShang() {
              this.pageNo = this.pageNo - 1;
              this.getZhijianData(this.pageNo)
          },
          zizhiCurrentPage(page) {
              this.pageNo = page;
          },
          zizhiXia() {
              this.pageNo = this.pageNo + 1;
              this.getZizhiData(this.pageNo)
          },
          zizhiShang() {
              this.pageNo = this.pageNo - 1;
              this.getZizhiData(this.pageNo)
          },
      }
  }
  </script>
  
  <style lang="less" scoped>
      .content {
          width: 1100px;
          margin-top: 15px;
          .content-box {
              background-color: #fff;
              padding: 10px;
              box-sizing: border-box;
  
              display: block;
              .top {
                  display: flex;
                  justify-content: space-between;
                  align-items: center;
                  padding: 15px 0;
                  border-bottom: 1px solid #ccc;
                  .left {
                      display: flex;
                      img {
                          width: 40px;
                          height: 40px;
                          margin: 0 15px;
                      }
                      .text {
                          color: #1677ff;
                          .title {
                              font-size: 24px;
                              font-weight: bold;
                          }
                          .en-text {
                              font-size: 14px;
                          }
                      }
                  }
                  .right {
                      color: #999;
                  }
              }
  
              .list {
                  margin: 30px 10px;
                  display: flex;
                  flex-wrap: wrap;
                  .item {
                      width: 22%;
                      padding: 20px;
                      box-sizing: border-box;
                      border: 1px solid #ddd;
                      margin: 20px;
                      &:nth-child(4n) {
                          margin-right: 3px;
                      }
                      &:nth-child(4n+1) {
                          margin-left: 4px;
                      }
                      .img {
                          width: 100%;
                          height: 160px;
                          padding-bottom: 20px;
                          border-bottom: 1px solid #ccc;
                      }
                      .info {
                          margin: 20px 0;
                          font-size: 14px;
                          .name {
                              display: flex;
                              .unit-icon {
                                  width: 17px;
                                  height: 20px;
                                  margin-right: 10px;
                              }
                          }
                      }
                      &:hover {
                          box-shadow: 0 0 15px #ccc;
                      }
                  }
              }
              .bottom {
                  display: flex;
                  justify-content: center;
              }
              &:hover {
                  box-shadow: 0 0 15px #ccc;
  
              }
          }
      }
  </style>
  